import { HoleCountIcon } from "@whoosh/design-system/src/components/icons_v2/courseLayout";
import { TeeSheetTransportationIcon } from "@whoosh/design-system/src/components/icons_v2/transportation";
import { Box, HStack } from "@whoosh/design-system/src/components/primitive";

import {
  HoleCount,
  TransportationCode,
} from "./__generated__/AgendaWaitlistBooking_Booking.graphql";

export const PlayerGolfIcons = ({
  holeCount,
  transportationType,
}: {
  holeCount: HoleCount;
  transportationType: TransportationCode;
}) => {
  return (
    <Box p={1} borderRadius="2" width="auto" backgroundColor="grayscale-200">
      <HStack>
        <TeeSheetTransportationIcon transportationType={transportationType} />
        <HoleCountIcon holeCount={holeCount} />
      </HStack>
    </Box>
  );
};
